import React, { useEffect } from "react"

export default function Script({ widget }) {
  const { scriptUrl } = widget || {}

  useEffect(() => {
    if (typeof document === "undefined" || !scriptUrl) {
      return undefined
    }

    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`)
    if (existingScript) {
      return undefined
    }

    const script = document.createElement("script")
    script.src = scriptUrl
    script.async = true
    document.body.appendChild(script)

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [scriptUrl])

  return null
}